{
  "reportingConfiguration": {
    "title": "Configuration du reporting",
    "information": "À intervalle régulier, un reporting sera transmis aux contacts configurés ci-dessous.",
    "frequency": "Périodicité du reporting (en jours)",
    "time": "Heure du reporting"
  },
  "recipients": {
    "title": "Destinataires",
    "users": {
      "empty": "Aucun destinataire",
      "select": {
        "label": "Ajouter des destinataires"
      },
      "add": {
        "label": "Ajouter des destinataires",
        "notification": {
          "success": "Les destinataires suivants ont été ajoutés"
        }
      },
      "remove": {
        "label": "Retirer les destinataires sélectionnés",
        "confirm": {
          "title": "Retirer les destinataires",
          "message": "Les destinataires suivants vont être retirés :"
        },
        "notification": {
          "success": "Les destinataires suivants ont été retirés"
        }
      }
    }
  },
  "validation": {
    "frequency": {
      "required": "La périodicité du reporting est obligatoire"
    },
    "time": {
      "required": "L'heure du reporting est obligatoire"
    }
  }
}
